import React from 'react';
import { MediaTypeEnum } from 'api';
import { observer } from 'mobx-react';
import 'react-image-crop/dist/ReactCrop.css';
import useStyles from './VideoUploader.styles';
import { EnhancedButton } from 'components/EnhancedButton';
import { useVideoUploader } from '../../hooks/useVideoUploader';
import { UploadTypeEnum } from '../../constants/UploadTypeEnum';
import { StyledDropzone } from 'components/StyledDropZone/StyledDropZone';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const VideoUploader: React.FC<Props> = observer(({ open, onClose }: Props) => {
  const classes = useStyles();
  const vm = useVideoUploader();

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      onClose={onClose}
      disableBackdropClick
      classes={{
        scrollPaper: classes.topScrollPaper,
        paperScrollBody: classes.topPaperScrollBody
      }}
    >
      <DialogTitle>Upload Video</DialogTitle>
      <DialogContent dividers className={classes.Content}>
        <FormControl variant="filled" size="small">
          <Select
            variant="outlined"
            disabled={vm.loading}
            value={vm.uploadType}
            id="upload-process-selector"
            onChange={(e) => vm.handleUploadTypeChange(e.target.value as UploadTypeEnum)}
          >
            <MenuItem value={UploadTypeEnum.URL}>Upload from URL</MenuItem>
            <MenuItem value={UploadTypeEnum.LOCAL_DISK}>Upload from disk</MenuItem>
          </Select>
        </FormControl>

        <div className={classes.FlexCol}>
          {vm.uploadType === UploadTypeEnum.URL && (
            <>
              <TextField
                fullWidth
                name="url"
                size="small"
                id="video-url"
                variant="outlined"
                value={vm.uploadParams.url}
                onChange={vm.handleUploadParamsChange}
                placeholder="Paste the link of your video"
              />

              <TextField
                fullWidth
                size="small"
                name="title"
                id="video-title"
                variant="outlined"
                value={vm.uploadParams.title}
                placeholder="Name of your video"
                onChange={vm.handleUploadParamsChange}
              />
            </>
          )}

          {vm.uploadType === UploadTypeEnum.LOCAL_DISK && (
            <>
              <TextField
                fullWidth
                size="small"
                name="title"
                id="video-title"
                variant="outlined"
                value={vm.uploadParams.title}
                placeholder="Name of your video"
                onChange={vm.handleUploadParamsChange}
              />
              {vm.videoSrc ? (
                <video src={vm.videoSrc} controls className={classes.Video} />
              ) : (
                <StyledDropzone onSelectFile={vm.onSelectFile} mediaType={MediaTypeEnum.VIDEO} multiple={false} />
              )}
            </>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        {vm.uploadType === UploadTypeEnum.LOCAL_DISK && (
          <Button
            size="small"
            variant="text"
            color="primary"
            disabled={vm.loading}
            onClick={vm.resetSelection}
            style={{ marginRight: 'auto' }}
          >
            Choose different video
          </Button>
        )}

        <Button disabled={vm.loading} variant="text" color="primary" size="small" onClick={onClose}>
          Cancel
        </Button>
        <EnhancedButton size="small" variant="contained" color="primary" onClick={vm.handleUpload} loading={vm.loading}>
          Upload
        </EnhancedButton>
      </DialogActions>
    </Dialog>
  );
});
